import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  role: "status",
  class: "skelton"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "grid grid-cols-6 justify-center gap-x-4 items-center place-items-center text-center pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (item) => {
          return _createElementVNode("div", {
            class: "transaction-title",
            key: item
          })
        }), 64))
      ])
    ])
  ]))
}